// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5d1c877f","977":"e1f627c1"}[chunkId] + ".chunk.js";
};